var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.downloadLoading,
          expression: "downloadLoading",
        },
      ],
      staticClass: "task-config-container",
    },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { placeholder: "选择商品", clearable: "" },
                      model: {
                        value: _vm.searchForm.productId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "productId", $$v)
                        },
                        expression: "searchForm.productId",
                      },
                    },
                    _vm._l(_vm.productList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.productName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入订单号", clearable: "" },
                    model: {
                      value: _vm.searchForm.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "orderNo", $$v)
                      },
                      expression: "searchForm.orderNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入手机号", clearable: "" },
                    model: {
                      value: _vm.searchForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "mobile", $$v)
                      },
                      expression: "searchForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "订单状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "派发中", value: "PENDING" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "派发失败", value: "FAILED" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已派发", value: "RECEIVE" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已完成", value: "USED" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已退款", value: "CANCEL" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.download } },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                border: "",
                "element-loading-text": "数据加载中...",
                "element-loading-spinner": "el-icon-loading",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "订单号", prop: "orderNo", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "thirdPartyNo",
                  label: "外部订单号",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "手机号", prop: "mobile", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "会员卡号", prop: "cardNo", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "兑换时间",
                  prop: "createDate",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单状态", prop: "status", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == "PENDING"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("派发中"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == "FAILED"
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("派发失败"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == "RECEIVE"
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("已派发"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == "USED"
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("已完成"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == "CANCEL"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("已退款"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "user-dialog",
          attrs: {
            title: "",
            "close-on-click-modal": true,
            visible: _vm.showUserDialog,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showUserDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.couponList, border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderOrginalNo",
                  label: "第三方订单号",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponName",
                  label: "优惠券名称",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "couponId", label: "优惠券ID", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "发放状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 0
                          ? _c("div", [_vm._v("发放中")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 1
                          ? _c("div", [_vm._v("已发放")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 2
                          ? _c("div", [_vm._v("发放失败")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 3
                          ? _c("div", [_vm._v("已作废")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "B端结算价", prop: "bprice", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "核销状态",
                  prop: "verifyStatus",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.verifyStatus == "0"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("未核销"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.verifyStatus == "1"
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("已核销"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "核销时间",
                  prop: "orderTime",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "核销订单号",
                  prop: "orderNo",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "核销门店",
                  prop: "orderStore",
                  align: "center",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { float: "right", "margin-top": "20px" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm2.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm2.limit,
                  total: _vm.searchForm2.total,
                },
                on: {
                  "current-change": _vm.handlePageChange2,
                  "size-change": _vm.handleSizeChange2,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }